import { useState } from "react";
import { MOCK } from "./MockData";
import { fmt } from "./Utils/Utilities";
import { Badge } from "./SharedUI";

// ─── Mock Data ────────────────────────────────────────────────────────────────
const GAS_PRODUCTS = [
  { id: "P001", name: "Industrial Oxygen",  unit: "kg",   maxQty: 5000 },
  { id: "P002", name: "Medical Oxygen",     unit: "kg",    maxQty: 3000 },
  { id: "P003", name: "Acetylene",          unit: "kg", maxQty: 500  },
  { id: "P004", name: "Food Grade CO₂",    unit: "kg",   maxQty: 2000 },
  { id: "P005", name: "LPG Bulk",          unit: "kg",   maxQty: 10000},
  { id: "P006", name: "Argon Mix",         unit: "kg",    maxQty: 2000 },
  { id: "P007", name: "Nitrogen",          unit: "kg",    maxQty: 5000 },
  { id: "P008", name: "Helium",            unit: "kg",    maxQty: 1000 },
  { id: "P009", name: "Propane",           unit: "kg",  maxQty: 1000 },
];

const DEPOTS = ["Johannesburg North", "Johannesburg South", "Centurion", "Midrand", "Vereeniging"];
const COLLECTORS = ["Thabo Nkosi", "R. Dlamini", "Sipho Mahlangu", "Bongani Dube", "Mandla Khumalo"];

const INITIAL_COLLECTIONS = [
  { id: "COL-0001", ProviderId: "C001", Provider: "Meridian Industrial Group", total: 1200,   depot: "Johannesburg North", type: "Delivery",  driver: "Sipho Mahlangu", vehicle: "GP 44-21 BT", collector: "Thabo Nkosi",   collectionDate: "2025-04-23", status: "Collected",  invoiceId: "INV-8821", notes: "Urgent order",        deliveryAddress: { street: "14 Steel Road", suburb: "Germiston", city: "Johannesburg", postalCode: "1401", province: "Gauteng" } },
  { id: "COL-0002", ProviderId: "C002", Provider: "Highveld Hospital Group", total: 4560,   depot: "Centurion",          type: "Delivery",  driver: "Bongani Dube",   vehicle: "GP 12-80 AX", collector: "R. Dlamini",    collectionDate: "2025-04-22", status: "Collected",  invoiceId: "INV-8822", notes: "",                    deliveryAddress: { street: "3 Hospital Drive", suburb: "Centurion", city: "Pretoria", postalCode: "0157", province: "Gauteng" } },
  { id: "COL-0003", ProviderId: "C003", Provider: "Vaal Engineering Co.", total: 36800,  depot: "Vereeniging",        type: "Pickup",    driver: null,             vehicle: null,          collector: "Thabo Nkosi",   collectionDate: "2025-04-28", status: "Ready",      invoiceId: null,       notes: "Provider collecting", deliveryAddress: null },
  { id: "COL-0004", ProviderId: "C004", Provider: "Savanna Foods (Pty) Ltd", total: 47500,  depot: "Centurion",          type: "Delivery",  driver: "Sipho Mahlangu", vehicle: "GP 44-21 BT", collector: "Thabo Nkosi",   collectionDate: "2025-04-26", status: "In Transit", invoiceId: null,       notes: "",                    deliveryAddress: { street: "22 Park Lane", suburb: "Midrand", city: "Johannesburg", postalCode: "1685", province: "Gauteng" } },
  { id: "COL-0005", ProviderId: "C005", Provider: "ProWeld Industries", total: 840,    depot: "Johannesburg North", type: "Delivery",  driver: "Mandla Khumalo", vehicle: "GP 33-09 DX", collector: "Thabo Nkosi",   collectionDate: "2025-04-27", status: "Confirmed",  invoiceId: null,       notes: "",                    deliveryAddress: { street: "8 Industria Blvd", suburb: "Industria", city: "Johannesburg", postalCode: "2093", province: "Gauteng" } },
  { id: "COL-0006", ProviderId: "C006", Provider: "FreshPak Beverages", total: 28500,  depot: "Midrand",            type: "Pickup",    driver: null,             vehicle: null,          collector: "R. Dlamini",    collectionDate: "2025-04-29", status: "Pending",    invoiceId: null,       notes: "Call before dispatch",deliveryAddress: null },
  { id: "COL-0007", ProviderId: "C007", Provider: "AutoMech Solutions", total: 270,    depot: "Johannesburg South", type: "Delivery",  driver: "Bongani Dube",   vehicle: "GP 12-80 AX", collector: "Thabo Nkosi",   collectionDate: "2025-04-27", status: "Collected",  invoiceId: "INV-8841", notes: "",                    deliveryAddress: { street: "5 Workshop Road", suburb: "Alberton", city: "Johannesburg", postalCode: "1449", province: "Gauteng" } },
];

const SA_PROVINCES = [
  "Gauteng", "Western Cape", "KwaZulu-Natal", "Eastern Cape",
  "Limpopo", "Mpumalanga", "North West", "Free State", "Northern Cape",
];

const STATUS_META = {
  Pending:     { color: "var(--amber)",   bg: "rgba(255,171,0,.1)",  border: "rgba(255,171,0,.25)",  icon: "bi-hourglass-split"       },
  Confirmed:   { color: "var(--blue)",    bg: "rgba(64,196,255,.1)", border: "rgba(64,196,255,.25)", icon: "bi-check-circle"          },
  Ready:       { color: "var(--teal)",    bg: "rgba(29,233,182,.1)", border: "rgba(29,233,182,.25)", icon: "bi-box-seam"              },
  "In Transit":{ color: "var(--blue)",    bg: "rgba(64,196,255,.1)", border: "rgba(64,196,255,.25)", icon: "bi-truck"                 },
  Collected:   { color: "var(--success)", bg: "rgba(0,230,118,.1)",  border: "rgba(0,230,118,.25)",  icon: "bi-check2-all"            },
  Cancelled:   { color: "var(--danger)",  bg: "rgba(255,23,68,.1)",  border: "rgba(255,23,68,.25)",  icon: "bi-x-circle"              },
};

const STATUS_FLOW = ["Pending", "Confirmed", "Ready", "In Transit", "Collected"];

// ─── Shared helpers ───────────────────────────────────────────────────────────
function StatusPill({ status }) {
  const s = STATUS_META[status] || STATUS_META["Pending"];
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 9px", borderRadius: 20, fontSize: 10, fontWeight: 700, color: s.color, background: s.bg, border: `1px solid ${s.border}` }}>
      <span style={{ width: 5, height: 5, borderRadius: "50%", background: s.color, display: "inline-block" }} />
      {status}
    </span>
  );
}

function genId(list) {
  return `COL-${String(list.length + 1).padStart(4, "0")}`;
}

function formatDeliveryAddress(addr) {
  if (!addr) return "—";
  return [addr.street, addr.suburb, addr.city, addr.postalCode, addr.province].filter(Boolean).join(", ");
}

// ─── New Collection Wizard ────────────────────────────────────────────────────
function NewCollectionWizard({ onClose, onConfirm }) {
  const Providers = MOCK?.Providers || [
    { id: "C001", name: "Meridian Industrial Group" },
    { id: "C002", name: "Highveld Hospital Group" },
    { id: "C003", name: "Vaal Engineering Co." },
    { id: "C004", name: "Savanna Foods (Pty) Ltd" },
    { id: "C005", name: "ProWeld Industries" },
    { id: "C006", name: "FreshPak Beverages" },
    { id: "C007", name: "AutoMech Solutions" },
  ];

  // If only 1 provider, auto-select and skip that step
  const singleProvider = Providers.length === 1;

  const [form, setForm] = useState({
    ProviderId:     singleProvider ? Providers[0].id   : "",
    Provider:       singleProvider ? Providers[0].name : "",
    productId:      "",
    product:        null,
    qty:            "",
    type:           "Delivery",
    depot:          DEPOTS[0],
    driver:         "",
    vehicle:        "",
    collector:      COLLECTORS[0],
    collectionDate: new Date().toISOString().slice(0, 10),
    notes:          "",
    deliveryAddress: {
      street:     "",
      suburb:     "",
      city:       "",
      postalCode: "",
      province:   "Gauteng",
    },
  });

  // Build step list dynamically
  // Steps: [Provider (skip if single)], Gas Type, Details, [Delivery Address (only if Delivery)], Confirm
  const buildSteps = () => {
    const steps = [];
    if (!singleProvider) steps.push({ key: "provider",  label: "Provider" });
    steps.push({ key: "gas",      label: "Gas Type"  });
    steps.push({ key: "details",  label: "Details"   });
    if (form.type === "Delivery") steps.push({ key: "address", label: "Address" });
    steps.push({ key: "confirm",  label: "Confirm"   });
    return steps;
  };

  const steps = buildSteps();
  const [stepIdx, setStepIdx] = useState(0);
  const currentStep = steps[stepIdx];

  // Recompute steps when type changes — if user changes type to Pickup on details step,
  // we need to drop the address step (and not overshoot)
  const prevType = useState(form.type)[0];

  const set  = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  const setE = (k) => (e) => set(k)(e.target.value);
  const setAddr = (k) => (e) => setForm((f) => ({ ...f, deliveryAddress: { ...f.deliveryAddress, [k]: e.target.value } }));

  const selectedProduct = GAS_PRODUCTS.find((p) => p.id === form.productId);

  const canNext = () => {
    if (currentStep.key === "provider") return !!form.ProviderId;
    if (currentStep.key === "gas")      return !!form.productId;
    if (currentStep.key === "details")  return form.qty > 0 && form.qty <= (selectedProduct?.maxQty || Infinity);
    if (currentStep.key === "address")  return !!(form.deliveryAddress.street && form.deliveryAddress.city && form.deliveryAddress.postalCode);
    return true;
  };

  const handleNext = () => {
    if (stepIdx < steps.length - 1) {
      // Rebuild steps at transition in case type changed
      const freshSteps = buildSteps();
      // find current key in fresh steps
      const freshIdx = freshSteps.findIndex((s) => s.key === currentStep.key);
      if (freshIdx < freshSteps.length - 1) {
        setStepIdx(freshIdx + 1);
      }
    } else {
      onConfirm(form, selectedProduct);
    }
  };

  const handleBack = () => {
    if (stepIdx === 0) { onClose(); return; }
    const freshSteps = buildSteps();
    const freshIdx = freshSteps.findIndex((s) => s.key === currentStep.key);
    setStepIdx(Math.max(0, freshIdx - 1));
  };

  // Always sync stepIdx against fresh step list when type toggles
  const handleTypeChange = (t) => {
    setForm((f) => ({ ...f, type: t }));
    // If switching to Pickup and we're on address step, move back to details
    if (t === "Pickup" && currentStep.key === "address") {
      setStepIdx((i) => i - 1);
    }
  };

  // Displayed step indicators — recalculate with latest form.type
  const displaySteps = buildSteps();

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.65)", backdropFilter: "blur(6px)", zIndex: 900, display: "flex", alignItems: "center", justifyContent: "center", animation: "fadein .15s" }}>
      <div style={{ background: "var(--surface)", border: "1px solid var(--bright)", borderRadius: 16, width: "90%", maxWidth: 560, display: "flex", flexDirection: "column", animation: "slup .18s ease", overflow: "hidden" }}>

        {/* header */}
        <div style={{ padding: "18px 22px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: "linear-gradient(135deg,var(--flame),var(--amber))", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>🚛</div>
          <div style={{ flex: 1 }}>
            <div className="syne fw7 fs14">New Collection</div>
            <div className="fs10 tc3">Gas order collection request</div>
          </div>
          <button className="btn btn-g btn-sm btn-ico" onClick={onClose}><i className="bi bi-x" style={{ fontSize: 14 }} /></button>
        </div>

        {/* step indicator */}
        <div style={{ padding: "14px 22px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 0 }}>
          {displaySteps.map((s, i) => {
            const sIdx      = displaySteps.findIndex((ds) => ds.key === s.key);
            const curGlobal = displaySteps.findIndex((ds) => ds.key === currentStep.key);
            const done      = sIdx < curGlobal;
            const active    = sIdx === curGlobal;
            return (
              <div key={s.key} style={{ display: "flex", alignItems: "center", flex: i < displaySteps.length - 1 ? 1 : 0 }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                  <div style={{
                    width: 28, height: 28, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700,
                    background: done ? "var(--success)" : active ? "var(--flame)" : "var(--elevated)",
                    color: done || active ? "#fff" : "var(--text3)",
                    border: `2px solid ${done ? "var(--success)" : active ? "var(--flame)" : "var(--border)"}`,
                    transition: "all .2s",
                  }}>
                    {done ? <i className="bi bi-check" /> : i + 1}
                  </div>
                  <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase", color: active ? "var(--flame)" : "var(--text3)" }}>{s.label}</span>
                </div>
                {i < displaySteps.length - 1 && (
                  <div style={{ flex: 1, height: 2, margin: "0 6px", marginBottom: 18, background: done ? "var(--success)" : "var(--border)", transition: "background .3s" }} />
                )}
              </div>
            );
          })}
        </div>

        {/* body */}
        <div style={{ padding: "22px", overflowY: "auto", minHeight: 240 }}>

          {/* Step: Provider (only when multiple providers) */}
          {currentStep.key === "provider" && (
            <div>
              <div className="fs12 fw6" style={{ marginBottom: 14 }}>Select the Provider</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {Providers.map((c) => (
                  <div
                    key={c.id}
                    onClick={() => setForm((f) => ({ ...f, ProviderId: c.id, Provider: c.name }))}
                    style={{
                      padding: "12px 14px", borderRadius: 10, cursor: "pointer",
                      border: `1px solid ${form.ProviderId === c.id ? "var(--flame)" : "var(--border)"}`,
                      background: form.ProviderId === c.id ? "rgba(255,79,23,.07)" : "var(--elevated)",
                      display: "flex", alignItems: "center", gap: 12, transition: "all .13s",
                    }}
                  >
                    <div style={{ width: 32, height: 32, borderRadius: "50%", background: "linear-gradient(135deg,var(--blue),var(--teal))", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "var(--deep)", flexShrink: 0 }}>
                      {c.name.split(" ").map((w) => w[0]).join("").slice(0, 2)}
                    </div>
                    <span className="fs12 fw6">{c.name}</span>
                    {form.ProviderId === c.id && <i className="bi bi-check-circle-fill" style={{ color: "var(--flame)", marginLeft: "auto" }} />}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Step: Gas Type */}
          {currentStep.key === "gas" && (
            <div>
              <div className="fs12 fw6" style={{ marginBottom: 14 }}>Select the gas product for this collection</div>
              {singleProvider && (
                <div style={{ background: "var(--elevated)", border: "1px solid var(--border)", borderRadius: 8, padding: "8px 12px", marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}>
                  <i className="bi bi-building" style={{ color: "var(--teal)", fontSize: 12 }} />
                  <span className="fs11 tc2">Provider: <strong style={{ color: "var(--text1)" }}>{form.Provider}</strong></span>
                </div>
              )}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                {GAS_PRODUCTS.map((p) => (
                  <div
                    key={p.id}
                    onClick={() => setForm((f) => ({ ...f, productId: p.id, product: p }))}
                    style={{
                      padding: "12px 14px", borderRadius: 10, cursor: "pointer",
                      border: `1px solid ${form.productId === p.id ? "var(--teal)" : "var(--border)"}`,
                      background: form.productId === p.id ? "rgba(29,233,182,.07)" : "var(--elevated)",
                      transition: "all .13s",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
                      <span className="fs12 fw6">{p.name}</span>
                      {form.productId === p.id && <i className="bi bi-check-circle-fill" style={{ color: "var(--teal)", fontSize: 12 }} />}
                    </div>
                    <div className="fs10 tc3">Max: {p.maxQty.toLocaleString()} {p.unit}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Step: Details */}
          {currentStep.key === "details" && selectedProduct && (
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              {/* qty */}
              <div>
                <label className="fl">Quantity ({selectedProduct.unit}) *</label>
                <input className="fi" type="number" min={1} max={selectedProduct.maxQty} value={form.qty} onChange={setE("qty")} placeholder={`Max ${selectedProduct.maxQty.toLocaleString()} ${selectedProduct.unit}`} />
                {form.qty && Number(form.qty) > selectedProduct.maxQty && (
                  <div className="fs10 t-danger" style={{ marginTop: 4 }}>Exceeds available stock of {selectedProduct.maxQty.toLocaleString()} {selectedProduct.unit}</div>
                )}
              </div>

              {/* collection type */}
              <div>
                <label className="fl">Collection Type *</label>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 6 }}>
                  {["Delivery", "Pickup"].map((t) => (
                    <div
                      key={t}
                      onClick={() => handleTypeChange(t)}
                      style={{
                        padding: "14px", borderRadius: 10, cursor: "pointer", textAlign: "center",
                        border: `1px solid ${form.type === t ? "var(--flame)" : "var(--border)"}`,
                        background: form.type === t ? "rgba(255,79,23,.08)" : "var(--elevated)",
                        transition: "all .13s",
                      }}
                    >
                      <div style={{ fontSize: 22, marginBottom: 6 }}>{t === "Delivery" ? "🚛" : "🏭"}</div>
                      <div className="fs12 fw6" style={{ color: form.type === t ? "var(--flame)" : "var(--text1)" }}>{t}</div>
                      <div className="fs10 tc3">{t === "Delivery" ? "We deliver to Provider" : "Provider collects from depot"}</div>
                    </div>
                  ))}
                </div>
                {form.type === "Delivery" && (
                  <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 6, padding: "6px 10px", background: "rgba(64,196,255,.07)", border: "1px solid rgba(64,196,255,.2)", borderRadius: 8 }}>
                    <i className="bi bi-info-circle" style={{ color: "var(--blue)", fontSize: 11 }} />
                    <span className="fs10 tc2">You'll enter the delivery address in the next step.</span>
                  </div>
                )}
              </div>

              {/* depot */}
              <div>
                <label className="fl">Depot</label>
                <select className="fsel" value={form.depot} onChange={setE("depot")}>
                  {DEPOTS.map((d) => <option key={d}>{d}</option>)}
                </select>
              </div>

              {/* driver – only if delivery */}
              {form.type === "Delivery" && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <div>
                    <label className="fl">Driver</label>
                    <input className="fi" value={form.driver} onChange={setE("driver")} placeholder="Driver name" />
                  </div>
                  <div>
                    <label className="fl">Vehicle Reg.</label>
                    <input className="fi" value={form.vehicle} onChange={setE("vehicle")} placeholder="GP 00-00 XX" />
                  </div>
                </div>
              )}

              {/* collector + date */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <div>
                  <label className="fl">Assigned Collector</label>
                  <select className="fsel" value={form.collector} onChange={setE("collector")}>
                    {COLLECTORS.map((c) => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div>
                  <label className="fl">Collection Date</label>
                  <input className="fi" type="date" value={form.collectionDate} onChange={setE("collectionDate")} />
                </div>
              </div>

              <div>
                <label className="fl">Notes</label>
                <input className="fi" value={form.notes} onChange={setE("notes")} placeholder="Special instructions…" />
              </div>
            </div>
          )}

          {/* Step: Delivery Address */}
          {currentStep.key === "address" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <div>
                <div className="fs12 fw6" style={{ marginBottom: 4 }}>Delivery Address</div>
                <div className="fs11 tc3">Where should this order be delivered to?</div>
              </div>

              <div>
                <label className="fl">Street Address *</label>
                <input
                  className="fi"
                  value={form.deliveryAddress.street}
                  onChange={setAddr("street")}
                  placeholder="e.g. 14 Industrial Road"
                />
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <div>
                  <label className="fl">Suburb</label>
                  <input
                    className="fi"
                    value={form.deliveryAddress.suburb}
                    onChange={setAddr("suburb")}
                    placeholder="e.g. Germiston"
                  />
                </div>
                <div>
                  <label className="fl">City *</label>
                  <input
                    className="fi"
                    value={form.deliveryAddress.city}
                    onChange={setAddr("city")}
                    placeholder="e.g. Johannesburg"
                  />
                </div>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <div>
                  <label className="fl">Postal Code *</label>
                  <input
                    className="fi"
                    value={form.deliveryAddress.postalCode}
                    onChange={setAddr("postalCode")}
                    placeholder="e.g. 1401"
                    maxLength={4}
                  />
                </div>
                <div>
                  <label className="fl">Province</label>
                  <select className="fsel" value={form.deliveryAddress.province} onChange={setAddr("province")}>
                    {SA_PROVINCES.map((p) => <option key={p}>{p}</option>)}
                  </select>
                </div>
              </div>

              {/* preview formatted address */}
              {(form.deliveryAddress.street || form.deliveryAddress.city) && (
                <div style={{ background: "var(--elevated)", border: "1px solid var(--border)", borderRadius: 10, padding: "12px 14px", display: "flex", gap: 10, alignItems: "flex-start" }}>
                  <i className="bi bi-geo-alt-fill" style={{ color: "var(--teal)", marginTop: 1, flexShrink: 0 }} />
                  <div>
                    <div className="fs10 fw7 tc3" style={{ textTransform: "uppercase", letterSpacing: ".08em", marginBottom: 4 }}>Address Preview</div>
                    <div className="fs12" style={{ lineHeight: 1.7 }}>
                      {form.deliveryAddress.street && <div>{form.deliveryAddress.street}</div>}
                      {(form.deliveryAddress.suburb || form.deliveryAddress.city) && (
                        <div>{[form.deliveryAddress.suburb, form.deliveryAddress.city].filter(Boolean).join(", ")}</div>
                      )}
                      {(form.deliveryAddress.postalCode || form.deliveryAddress.province) && (
                        <div>{[form.deliveryAddress.postalCode, form.deliveryAddress.province].filter(Boolean).join(", ")}</div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Step: Confirm */}
          {currentStep.key === "confirm" && selectedProduct && (
            <div>
              <div style={{ background: "var(--elevated)", border: "1px solid var(--border)", borderRadius: 12, padding: "18px 20px", marginBottom: 16 }}>
                <div className="fs11 fw7 tc3" style={{ textTransform: "uppercase", letterSpacing: ".1em", marginBottom: 14 }}>Collection Summary</div>
                {[
                  ["Provider",         form.Provider],
                  ["Product",          selectedProduct.name],
                  ["Quantity",         `${Number(form.qty).toLocaleString()} ${selectedProduct.unit}`],
                  ["Type",             form.type],
                  ["Depot",            form.depot],
                  ...(form.type === "Delivery" ? [
                    ["Driver",   form.driver  || "—"],
                    ["Vehicle",  form.vehicle || "—"],
                    ["Delivery Address", formatDeliveryAddress(form.deliveryAddress)],
                  ] : []),
                  ["Collector",        form.collector],
                  ["Collection Date",  form.collectionDate],
                  ...(form.notes ? [["Notes", form.notes]] : []),
                ].map(([k, v]) => (
                  <div key={k} className="fb" style={{ paddingBottom: 10, marginBottom: 10, borderBottom: "1px solid var(--border)", flexWrap: k === "Delivery Address" ? "wrap" : "nowrap", gap: k === "Delivery Address" ? 4 : 0 }}>
                    <span className="fs11 tc3" style={{ flexShrink: 0 }}>{k}</span>
                    <span className="fs11 fw6" style={{ color: "var(--text1)", textAlign: "right", maxWidth: k === "Delivery Address" ? "100%" : "60%" }}>{v}</span>
                  </div>
                ))}
              </div>
              <div style={{ background: "rgba(29,233,182,.07)", border: "1px solid rgba(29,233,182,.2)", borderRadius: 10, padding: "10px 14px", display: "flex", gap: 8, alignItems: "center" }}>
                <i className="bi bi-info-circle" style={{ color: "var(--teal)", flexShrink: 0 }} />
                <span className="fs11 tc2">Confirming will create the collection record with <strong>Pending</strong> status. Stock will be allocated on confirmation.</span>
              </div>
            </div>
          )}
        </div>

        {/* footer */}
        <div style={{ padding: "14px 22px", borderTop: "1px solid var(--border)", display: "flex", justifyContent: "space-between", gap: 10 }}>
          <button className="btn btn-g" onClick={handleBack}>
            {stepIdx === 0 ? "Cancel" : <><i className="bi bi-arrow-left" style={{ fontSize: 11 }} /> Back</>}
          </button>
          <button
            className="btn btn-p"
            disabled={!canNext()}
            style={{ opacity: canNext() ? 1 : .4 }}
            onClick={handleNext}
          >
            {currentStep.key === "confirm"
              ? <><i className="bi bi-check2" /> Confirm Collection</>
              : <>Next <i className="bi bi-arrow-right" style={{ fontSize: 11 }} /></>}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Delivery Note (print/download) ──────────────────────────────────────────
function DeliveryNote({ collection, onClose }) {
  const handlePrint = () => window.print();

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.75)", backdropFilter: "blur(8px)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 14, width: "90%", maxWidth: 640, maxHeight: "90vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
        {/* controls */}
        <div style={{ padding: "12px 18px", borderBottom: "1px solid var(--border)", display: "flex", gap: 8, justifyContent: "flex-end", alignItems: "center" }}>
          <span className="fs11 tc3" style={{ flex: 1 }}>Delivery Note — {collection.id}</span>
          <button className="btn btn-s btn-sm" onClick={handlePrint}><i className="bi bi-printer" /> Print</button>
          <button className="btn btn-p btn-sm" onClick={handlePrint}><i className="bi bi-download" /> Download PDF</button>
          <button className="btn btn-g btn-sm btn-ico" onClick={onClose}><i className="bi bi-x" style={{ fontSize: 14 }} /></button>
        </div>

        {/* document */}
        <div id="delivery-note" style={{ overflowY: "auto", flex: 1, padding: "32px 40px", background: "#fff", color: "#111" }}>
          {/* letterhead */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 32, paddingBottom: 20, borderBottom: "3px solid #ff4f17" }}>
            <div>
              <div style={{ fontWeight: 900, fontSize: 22, fontFamily: "sans-serif", color: "#ff4f17", letterSpacing: ".04em" }}>GasCRM</div>
              <div style={{ fontSize: 11, color: "#666", marginTop: 2 }}>Industrial Gas Supply & Distribution</div>
              <div style={{ fontSize: 10, color: "#999", marginTop: 8, lineHeight: 1.6 }}>
                14 Industrial Road, Johannesburg North<br />
                Tel: +27 11 555 0100 · info@gascrm.co.za<br />
                VAT No: 4230198765
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: 18, fontWeight: 900, color: "#111", marginBottom: 4 }}>DELIVERY NOTE</div>
              <div style={{ fontSize: 12, color: "#555" }}>No: <strong>{collection.id}</strong></div>
              <div style={{ fontSize: 12, color: "#555" }}>Date: <strong>{collection.collectionDate}</strong></div>
              {collection.invoiceId && <div style={{ fontSize: 12, color: "#555" }}>Invoice: <strong>{collection.invoiceId}</strong></div>}
            </div>
          </div>

          {/* parties */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginBottom: 28 }}>
            <div>
              <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", color: "#999", marginBottom: 8 }}>Supplier</div>
              <div style={{ fontSize: 12, lineHeight: 1.7, color: "#222" }}>
                <strong>GasCRM (Pty) Ltd</strong><br />
                Depot: {collection.depot}<br />
                Tel: +27 11 555 0100
              </div>
            </div>
            <div>
              <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", color: "#999", marginBottom: 8 }}>
                {collection.type === "Delivery" ? "Deliver To" : "Provider"}
              </div>
              <div style={{ fontSize: 12, lineHeight: 1.7, color: "#222" }}>
                <strong>{collection.Provider}</strong><br />
                Account: {collection.ProviderId}<br />
                {collection.type === "Delivery" && collection.deliveryAddress && (
                  <>
                    {collection.deliveryAddress.street}<br />
                    {[collection.deliveryAddress.suburb, collection.deliveryAddress.city].filter(Boolean).join(", ")}<br />
                    {[collection.deliveryAddress.postalCode, collection.deliveryAddress.province].filter(Boolean).join(", ")}
                  </>
                )}
                {collection.type === "Pickup" && <span style={{ color: "#888" }}>Collection Type: Pickup</span>}
              </div>
            </div>
          </div>

          {/* items table */}
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 28, fontSize: 12 }}>
            <thead>
              <tr style={{ background: "#f5f5f5", borderBottom: "2px solid #ddd" }}>
                {["#", "Product / Gas Type", "Qty", "Unit", "Unit Price", "Total"].map((h) => (
                  <th key={h} style={{ padding: "9px 12px", textAlign: "left", fontSize: 10, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", color: "#666" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "10px 12px", color: "#888" }}>1</td>
                <td style={{ padding: "10px 12px", fontWeight: 600 }}>{collection.product || "—"}</td>
                <td style={{ padding: "10px 12px", fontFamily: "monospace" }}>{collection.qty ? collection.qty.toLocaleString() : "—"}</td>
                <td style={{ padding: "10px 12px", color: "#888" }}>{collection.unit || "—"}</td>
                <td style={{ padding: "10px 12px", fontFamily: "monospace" }}>{collection.qty ? `R${(collection.total / collection.qty).toFixed(2)}` : "—"}</td>
                <td style={{ padding: "10px 12px", fontFamily: "monospace", fontWeight: 700 }}>R{(collection.total || 0).toLocaleString("en-ZA", { minimumFractionDigits: 2 })}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr style={{ borderTop: "2px solid #333" }}>
                <td colSpan={5} style={{ padding: "10px 12px", textAlign: "right", fontWeight: 700, fontSize: 12 }}>TOTAL (excl. VAT)</td>
                <td style={{ padding: "10px 12px", fontFamily: "monospace", fontWeight: 900, fontSize: 14, color: "#ff4f17" }}>R{collection.total.toLocaleString("en-ZA", { minimumFractionDigits: 2 })}</td>
              </tr>
            </tfoot>
          </table>

          {/* driver info */}
          {collection.type === "Delivery" && (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginBottom: 28, padding: "14px 16px", background: "#f9f9f9", borderRadius: 8, border: "1px solid #eee" }}>
              <div>
                <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", color: "#999", marginBottom: 6 }}>Driver Details</div>
                <div style={{ fontSize: 12, color: "#222" }}><strong>{collection.driver || "—"}</strong></div>
                <div style={{ fontSize: 11, color: "#888" }}>Vehicle: {collection.vehicle || "—"}</div>
              </div>
              <div>
                <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", color: "#999", marginBottom: 6 }}>Collector / Agent</div>
                <div style={{ fontSize: 12, color: "#222" }}><strong>{collection.collector}</strong></div>
              </div>
            </div>
          )}

          {/* notes */}
          {collection.notes && (
            <div style={{ marginBottom: 28, padding: "12px 14px", background: "#fffbf0", border: "1px solid #ffe082", borderRadius: 6 }}>
              <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", color: "#999", marginBottom: 4 }}>Notes</div>
              <div style={{ fontSize: 12, color: "#555" }}>{collection.notes}</div>
            </div>
          )}

          {/* signatures */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 40, marginTop: 40 }}>
            {["Issued By (GasCRM)", "Received By (Provider)"].map((label) => (
              <div key={label}>
                <div style={{ height: 48, borderBottom: "1.5px solid #333", marginBottom: 6 }} />
                <div style={{ fontSize: 10, color: "#888" }}>{label}</div>
                <div style={{ fontSize: 10, color: "#bbb", marginTop: 2 }}>Signature / Date</div>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 28, paddingTop: 14, borderTop: "1px solid #eee", fontSize: 9, color: "#bbb", textAlign: "center" }}>
            This document is computer generated. GasCRM (Pty) Ltd · Reg No: 2010/123456/07 · VAT No: 4230198765
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Collection Detail Page ───────────────────────────────────────────────────
function CollectionDetailPage({ collection, onBack, onStatusAdvance, showToast: toast }) {
  const [showNote, setShowNote] = useState(false);
  const currentStep = STATUS_FLOW.indexOf(collection.status);

  return (
    <div className="page">
      {/* breadcrumb */}
      <div className="fc gap8 mb16">
        <button className="btn btn-g btn-sm" onClick={onBack} style={{ gap: 5 }}>
          <i className="bi bi-arrow-left" style={{ fontSize: 11 }} /> Collections
        </button>
        <span className="tc3 fs11">/</span>
        <span className="fs11 tc2">{collection.id}</span>
      </div>

      {/* hero */}
      <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 14, padding: "20px 22px", marginBottom: 16, display: "flex", alignItems: "center", gap: 18, flexWrap: "wrap" }}>
        <div style={{ width: 52, height: 52, borderRadius: 14, background: "linear-gradient(135deg,var(--teal),var(--blue))", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, boxShadow: "0 0 22px rgba(29,233,182,.25)", flexShrink: 0 }}>
          {collection.type === "Delivery" ? "🚛" : "🏭"}
        </div>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <span className="syne fw7" style={{ fontSize: 18 }}>{collection.Provider}</span>
            <span className="mono t-flame" style={{ fontSize: 11 }}>{collection.id}</span>
            <StatusPill status={collection.status} />
            <span className="tag">{collection.type}</span>
          </div>
          <div className="fc gap12" style={{ marginTop: 6, flexWrap: "wrap" }}>
            <span className="fs11 tc2"><i className="bi bi-box-seam" style={{ marginRight: 4 }} />{collection.product || "—"}</span>
            <span className="fs11 tc2"><i className="bi bi-rulers" style={{ marginRight: 4 }} />{collection.qty ? `${collection.qty.toLocaleString()} ${collection.unit || ''}` : "—"}</span>
            <span className="fs11 tc2"><i className="bi bi-geo-alt" style={{ marginRight: 4 }} />{collection.depot}</span>
            <span className="fs11 tc2"><i className="bi bi-calendar3" style={{ marginRight: 4 }} />{collection.collectionDate}</span>
          </div>
        </div>
        <div className="fc gap8">
          <button className="btn btn-p btn-sm" onClick={() => setShowNote(true)}>
            <i className="bi bi-file-earmark-text" /> Delivery Note
          </button>
          {collection.status !== "Collected" && collection.status !== "Cancelled" && (
            <button className="btn btn-s btn-sm" onClick={() => onStatusAdvance(collection)}>
              <i className="bi bi-arrow-right-circle" /> Advance Status
            </button>
          )}
        </div>

        <div className="fs11 fw7 tc3" style={{ textTransform: "uppercase", letterSpacing: ".1em", marginBottom: 16 }}>Collection Progress</div>
        <div style={{ display: "flex", alignItems: "center" }}>
          {STATUS_FLOW.map((s, i) => {
            const done   = i <= currentStep;
            const active = i === currentStep;
            const meta   = STATUS_META[s];
            return (
              <div key={s} style={{ display: "flex", alignItems: "center", flex: i < STATUS_FLOW.length - 1 ? 1 : 0 }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                  <div style={{
                    width: 32, height: 32, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13,
                    background: done ? (active ? meta.color : "var(--success)") : "var(--elevated)",
                    color: done ? "#fff" : "var(--text3)",
                    border: `2px solid ${done ? (active ? meta.color : "var(--success)") : "var(--border)"}`,
                    boxShadow: active ? `0 0 14px ${meta.color}55` : "none",
                    transition: "all .2s",
                  }}>
                    <i className={`bi ${done && !active ? "bi-check" : meta.icon}`} />
                  </div>
                  <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase", color: active ? meta.color : done ? "var(--success)" : "var(--text3)", whiteSpace: "nowrap" }}>{s}</span>
                </div>
                {i < STATUS_FLOW.length - 1 && (
                  <div style={{ flex: 1, height: 2, margin: "0 6px", marginBottom: 20, background: i < currentStep ? "var(--success)" : "var(--border)", transition: "background .3s" }} />
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* detail grid */}
      <div className="g6040">
        {/* left */}
        <div className="panel">
          <div className="ph"><span className="ph-title">Collection Details</span></div>
          <div style={{ padding: "14px 18px" }}>
            {[
              ["Collection ID",  collection.id],
              ["Provider",       collection.Provider],
              ["Product",        collection.product || "—"],
              ["Quantity",       collection.qty ? `${collection.qty.toLocaleString()} ${collection.unit || ''}` : "—"],
              ["Total Value",    `R${(collection.total || 0).toLocaleString("en-ZA", { minimumFractionDigits: 2 })}`],
              ["Type",           collection.type],
              ["Depot",          collection.depot],
              ["Collector",      collection.collector],
              ["Date",           collection.collectionDate],
              ...(collection.invoiceId ? [["Invoice", collection.invoiceId]] : []),
              ...(collection.notes ? [["Notes", collection.notes]] : []),
            ].map(([k, v]) => (
              <div key={k} className="fb" style={{ paddingBottom: 10, marginBottom: 10, borderBottom: "1px solid var(--border)" }}>
                <span className="fs11 tc3">{k}</span>
                <span className="fs11 fw6" style={{ color: k === "Total Value" ? "var(--teal)" : "var(--text1)" }}>{v}</span>
              </div>
            ))}
          </div>
        </div>

        {/* right */}
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {/* driver card */}
          {collection.type === "Delivery" && (
            <div className="panel">
              <div className="ph"><span className="ph-title">Driver & Vehicle</span></div>
              <div style={{ padding: "14px 18px" }}>
                <div className="fc gap12" style={{ marginBottom: 14 }}>
                  <div style={{ width: 40, height: 40, borderRadius: "50%", background: "linear-gradient(135deg,var(--blue),var(--teal))", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, color: "var(--deep)" }}>
                    {(collection.driver || "?").split(" ").map((n) => n[0]).join("")}
                  </div>
                  <div>
                    <div className="fs12 fw6">{collection.driver || "Not assigned"}</div>
                    <div className="fs10 tc3">Driver</div>
                  </div>
                </div>
                <div className="fb" style={{ paddingBottom: 10, marginBottom: 10, borderBottom: "1px solid var(--border)" }}>
                  <span className="fs11 tc3">Vehicle</span>
                  <span className="mono fs11 fw6">{collection.vehicle || "—"}</span>
                </div>
                <div className="fb">
                  <span className="fs11 tc3">Depot</span>
                  <span className="fs11 fw6">{collection.depot}</span>
                </div>
              </div>
            </div>
          )}

          {/* delivery address card */}
          {collection.type === "Delivery" && (
            <div className="panel">
              <div className="ph"><span className="ph-title">Delivery Address</span></div>
              <div style={{ padding: "14px 18px" }}>
                {collection.deliveryAddress ? (
                  <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                    <i className="bi bi-geo-alt-fill" style={{ color: "var(--teal)", marginTop: 2, flexShrink: 0 }} />
                    <div className="fs12" style={{ lineHeight: 1.8 }}>
                      {collection.deliveryAddress.street && <div>{collection.deliveryAddress.street}</div>}
                      {(collection.deliveryAddress.suburb || collection.deliveryAddress.city) && (
                        <div className="tc2">{[collection.deliveryAddress.suburb, collection.deliveryAddress.city].filter(Boolean).join(", ")}</div>
                      )}
                      {(collection.deliveryAddress.postalCode || collection.deliveryAddress.province) && (
                        <div className="tc2">{[collection.deliveryAddress.postalCode, collection.deliveryAddress.province].filter(Boolean).join(", ")}</div>
                      )}
                    </div>
                  </div>
                ) : (
                  <span className="fs11 tc3">No delivery address on record</span>
                )}
              </div>
            </div>
          )}

          {/* quick actions */}
          <div className="panel">
            <div className="ph"><span className="ph-title">Actions</span></div>
            <div style={{ padding: "12px 18px", display: "flex", flexDirection: "column", gap: 8 }}>
              <button className="btn btn-s" style={{ justifyContent: "flex-start", width: "100%" }} onClick={() => setShowNote(true)}>
                <i className="bi bi-file-earmark-text" style={{ fontSize: 13 }} /> View Delivery Note
              </button>
              <button className="btn btn-s" style={{ justifyContent: "flex-start", width: "100%" }} onClick={() => setShowNote(true)}>
                <i className="bi bi-download" style={{ fontSize: 13 }} /> Download Delivery Note
              </button>
              <button className="btn btn-s" style={{ justifyContent: "flex-start", width: "100%" }} onClick={() => toast("Contact logged", "s")}>
                <i className="bi bi-telephone" style={{ fontSize: 13 }} /> Log Contact
              </button>
              {collection.status !== "Collected" && collection.status !== "Cancelled" && (
                <button className="btn btn-d" style={{ justifyContent: "flex-start", width: "100%" }} onClick={() => toast("Collection cancelled", "w")}>
                  <i className="bi bi-x-circle" style={{ fontSize: 13 }} /> Cancel Collection
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {showNote && <DeliveryNote collection={collection} onClose={() => setShowNote(false)} />}
    </div>
  );
}

// ─── Main Collection Page ─────────────────────────────────────────────────────
function CollectionPage({ showToast: toast }) {
  const [collections, setCollections] = useState(INITIAL_COLLECTIONS);
  const [tab,         setTab]         = useState("All");
  const [search,      setSearch]      = useState("");
  const [showWizard,  setShowWizard]  = useState(false);
  const [detail,      setDetail]      = useState(null);

  const tabs = ["All", "Pending", "Confirmed", "Ready", "In Transit", "Collected"];

  const filtered = collections.filter((c) => {
    const q = search.toLowerCase();
    return (
      (c.Provider.toLowerCase().includes(q) || c.id.toLowerCase().includes(q) || (c.product || "").toLowerCase().includes(q)) &&
      (tab === "All" || c.status === tab)
    );
  });

  const kpis = [
    { label: "Pending",    color: "var(--amber)",   icon: "bi-hourglass-split" },
    { label: "In Transit", color: "var(--blue)",    icon: "bi-truck"           },
    { label: "Ready",      color: "var(--teal)",    icon: "bi-box-seam"        },
    { label: "Collected",  color: "var(--success)", icon: "bi-check2-all"      },
  ].map((k) => ({
    ...k,
    count: collections.filter((c) => c.status === k.label).length,
    value: collections.filter((c) => c.status === k.label).reduce((s, c) => s + c.total, 0),
  }));

  const handleConfirm = (form, product) => {
    const newC = {
      id:              genId(collections),
      ProviderId:      form.ProviderId,
      Provider:        form.Provider,
      product:         product.name,
      qty:             Number(form.qty),
      unit:            product.unit,
      total:           0, // price not tracked in this mock — set as needed
      depot:           form.depot,
      type:            form.type,
      driver:          form.driver  || null,
      vehicle:         form.vehicle || null,
      collector:       form.collector,
      collectionDate:  form.collectionDate,
      status:          "Pending",
      invoiceId:       null,
      notes:           form.notes,
      deliveryAddress: form.type === "Delivery" ? { ...form.deliveryAddress } : null,
    };
    setCollections((p) => [newC, ...p]);
    setShowWizard(false);
    toast(`Collection ${newC.id} created`, "s");
  };

  const advanceStatus = (col) => {
    const idx  = STATUS_FLOW.indexOf(col.status);
    const next = STATUS_FLOW[idx + 1];
    if (!next) return;
    setCollections((p) => p.map((c) => c.id === col.id ? { ...c, status: next } : c));
    if (detail?.id === col.id) setDetail((d) => ({ ...d, status: next }));
    toast(`${col.id} → ${next}`, "s");
  };

  if (detail) {
    const live = collections.find((c) => c.id === detail.id) || detail;
    return (
      <CollectionDetailPage
        collection={live}
        onBack={() => setDetail(null)}
        onStatusAdvance={advanceStatus}
        showToast={toast}
      />
    );
  }

  return (
    <div className="page">
      {/* KPI row */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 16 }}>
        {kpis.map((k) => (
          <div key={k.label} style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 12, padding: 16, cursor: "pointer", transition: "border-color .15s" }}
            onClick={() => setTab(k.label)}
          >
            <div className="fc gap8 mb8">
              <i className={`bi ${k.icon}`} style={{ fontSize: 16, color: k.color }} />
              <span className="fs11 tc2 fw6">{k.label}</span>
            </div>
            <div className="syne fw7" style={{ fontSize: 20, color: k.color }}>
              R{k.value.toLocaleString("en-ZA", { minimumFractionDigits: 0 })}
            </div>
            <div className="fs10 tc3 mono" style={{ marginTop: 4 }}>{k.count} collection{k.count !== 1 ? "s" : ""}</div>
          </div>
        ))}
      </div>

      <div className="panel">
        <div className="tbar">
          <div className="tabs">
            {tabs.map((t) => (
              <div key={t} className={`tab ${tab === t ? "on" : ""}`} onClick={() => setTab(t)}>{t}</div>
            ))}
          </div>
          <div className="tsearch" style={{ marginLeft: "auto" }}>
            <i className="bi bi-search" style={{ color: "var(--text3)", fontSize: 12 }} />
            <input placeholder="Search collections…" value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          <button className="btn btn-p" onClick={() => setShowWizard(true)}>
            <i className="bi bi-plus-lg" /> New Collection
          </button>
          <span className="fs11 tc3 mono">{filtered.length} records</span>
        </div>

        <table className="tbl">
          <thead>
            <tr>
              <th>ID</th>
              <th>Provider</th>
              <th>Product</th>
              <th>Qty</th>
              <th>Value</th>
              <th>Type</th>
              <th>Depot</th>
              <th>Driver</th>
              <th>Date</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((c) => (
              <tr key={c.id} style={{ cursor: "pointer" }} onClick={() => setDetail(c)}>
                <td className="mono t-flame" style={{ fontSize: 11 }}>{c.id}</td>
                <td className="fs12 fw6" style={{ maxWidth: 150, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.Provider}</td>
                <td className="fs11 tc2" style={{ maxWidth: 130, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.product || "—"}</td>
                <td className="mono fs11">{c.qty ? `${c.qty.toLocaleString()} ${c.unit || ''}` : <span className="tc3">—</span>}</td>
                <td className="mono fw7 fs12">R{(c.total || 0).toLocaleString("en-ZA", { minimumFractionDigits: 0 })}</td>
                <td><span className="tag">{c.type}</span></td>
                <td className="fs11 tc2" style={{ maxWidth: 130, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.depot}</td>
                <td className="fs11 tc2">{c.driver || <span className="tc3">—</span>}</td>
                <td className="mono fs10 tc3">{c.collectionDate}</td>
                <td><StatusPill status={c.status} /></td>
                <td><i className="bi bi-chevron-right" style={{ fontSize: 10, color: "var(--text3)" }} /></td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={11}>
                  <div className="empty">
                    <div className="empty-ico">🚛</div>
                    No collections found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showWizard && (
        <NewCollectionWizard
          onClose={() => setShowWizard(false)}
          onConfirm={handleConfirm}
        />
      )}
    </div>
  );
}

export default CollectionPage;